import { Link } from 'react-router-dom';
import { allCategories, allTopics } from '@/utils/data';

const friendLinks = ['光影志', '声浪音乐台', '星闻观察', '潮流前线', '城市生活志'];

const socials = [
  { icon: 'ri-wechat-fill', label: '微信' },
  { icon: 'ri-weibo-fill', label: '微博' },
  { icon: 'ri-qq-fill', label: 'QQ' },
  { icon: 'ri-bilibili-fill', label: '哔哩哔哩' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-brand text-2xl leading-none text-background-50">色哟哟</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-100/70">
              色哟哟是多元娱乐资讯平台，聚焦影视、音乐、明星动态与潮流趋势，为你带去及时、丰富、有态度的娱乐内容。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {socials.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-100/80 transition-colors hover:bg-primary-500 hover:text-background-50 cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">内容分类</h4>
            <ul className="mt-4 space-y-2.5">
              {allCategories.map((c) => (
                <li key={c.id}>
                  <Link to={`/category/${c.slug}`} className="text-sm text-background-100/70 transition-colors hover:text-primary-300 cursor-pointer">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">精选专题</h4>
            <ul className="mt-4 space-y-2.5">
              {allTopics.map((t) => (
                <li key={t.id}>
                  <Link to={`/category/${t.slug}`} className="text-sm text-background-100/70 transition-colors hover:text-primary-300 cursor-pointer">
                    {t.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">友情链接</h4>
            <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-2.5">
              {friendLinks.map((f) => (
                <li key={f}>
                  <span className="text-sm text-background-100/70 transition-colors hover:text-primary-300 cursor-pointer">{f}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/about"
              className="mt-4 inline-flex items-center gap-1 text-sm text-primary-300 transition-colors hover:text-primary-200 cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 text-xs text-background-100/60 sm:flex-row">
          <p>© 2026 色哟哟 · 多元娱乐资讯平台　保留所有权利</p>
          <p>本站内容为演示用途，资讯与人物均为虚构</p>
        </div>
      </div>
    </footer>
  );
}